export default function AreaController($scope, $state, $q, DataService, MapService, MapDrawService, TitleService, NotificationService) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.areaId = $state.params.areaId;
		vm.loading = true;
		DataService.getArea(vm.areaId).then((area) => {
			TitleService.setTitleOrg(area);

			vm.area = area;
			vm.assigned = DataService.getAssignedOrgs(vm.area);
			vm.map = DataService.instantMap();
			vm.recenter();

			DataService.setMapOpts({selectedOrg: vm.area, automaticOrgs: vm.assigned});

			let promises = (vm.assigned || []).map(DataService.loadDetails);
			return $q.all(promises).then(() => {
				vm.groups = MapService.groupByType(vm.assigned);

				vm.loading = false;
			});
		}, NotificationService.exception(vm));
	};

	vm.recenter = () => {
		MapService.centerMap(vm.area, vm.map);
	};


	vm.editArea = () => {
		$state.go("area-edit", {areaId: vm.areaId});
	};
}
